import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/roleGroupActions";
import * as api from "../../api/roleGroupApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getRoleGroupByID(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getRoleGroupDetailByID(action.payload);
        yield put(actions.setRoleGroupbyID(data || undefined));
    } catch (error) {
        yield put(actions.setRoleGroupbyID(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getRoleGroupList() {
    try {
        const { data } = yield api.getRoleGroupList();
        yield put(actions.setRoleGroupList(data || undefined));
    } catch (error) {
        yield put(actions.setRoleGroupList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addRoleGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addRoleGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateRoleGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateRoleGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteRoleGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteRoleGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getRoleFunctionList() {
    try {
        const { data } = yield api.getRoleFunctionList();
        yield put(actions.setRoleFunctionList(data || undefined));
    } catch (error) {
        yield put(actions.setRoleFunctionList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getRoleMenuList() {
    console.log("icerde");
    try {
        const { data } = yield api.getRoleMenuList();
        yield put(actions.setRoleMenuList(data || undefined));
    } catch (error) {
        yield put(actions.setRoleMenuList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* editRelation(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.editRelations(action.payload);
        yield put(actions.seteditRelation(data || undefined));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(actions.seteditRelation(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_ROLE_GROUP_BY_ID, getRoleGroupByID);
    yield takeEvery(actions.Types.GET_ROLE_FUNCTION_LIST, getRoleFunctionList);
    yield takeEvery(actions.Types.GET_ROLE_MENU_LIST, getRoleMenuList);
    yield takeEvery(actions.Types.EDIT_RELATION, editRelation);
    yield takeEvery(actions.Types.GET_ROLE_GROUP_LIST, getRoleGroupList);
    yield takeEvery(actions.Types.ADD_ROLE_GROUP, addRoleGroup);
    yield takeEvery(actions.Types.UPDATE_ROLE_GROUP, updateRoleGroup);
    yield takeEvery(actions.Types.DELETE_ROLE_GROUP, deleteRoleGroup);
}

const roleGroupSagas = [fork(watchAll)];

export default roleGroupSagas;
